import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from '../store.utils';
import {
  getPhoneCasesListAsyncThunk,
  getPhoneCaseByIdAsyncThunk,
  createPhoneCaseAsyncThunk,
  updatePhoneCaseAsyncThunk,
  deletePhoneCaseAsyncThunk,
  togglePhoneCaseActiveAsyncThunk,
} from './phoneCases.action';

// ---------- LIST ----------
const phoneCasesListSlice = createCustomSlice(
  'phoneCases/phoneCasesList',
  getPhoneCasesListAsyncThunk
);

// ---------- GET BY ID ----------
const phoneCaseByIdSlice = createCustomSlice(
  'phoneCases/phoneCaseById',
  getPhoneCaseByIdAsyncThunk
);

// ---------- CREATE ----------
const phoneCaseCreateSlice = createCustomSlice(
  'phoneCases/createPhoneCase',
  createPhoneCaseAsyncThunk
);

// ---------- UPDATE ----------
const phoneCaseUpdateSlice = createCustomSlice(
  'phoneCases/updatePhoneCase',
  updatePhoneCaseAsyncThunk
);

// ---------- DELETE ----------
const phoneCaseDeleteSlice = createCustomSlice(
  'phoneCases/deletePhoneCase',
  deletePhoneCaseAsyncThunk
);

// ---------- TOGGLE ACTIVE ----------
const phoneCaseToggleActiveSlice = createCustomSlice(
  'phoneCases/togglePhoneCaseActive',
  togglePhoneCaseActiveAsyncThunk
);

export const { reset: resetPhoneCasesList } = phoneCasesListSlice.actions;
export const { reset: resetPhoneCaseById } = phoneCaseByIdSlice.actions;
export const { reset: resetPhoneCaseCreate } = phoneCaseCreateSlice.actions;
export const { reset: resetPhoneCaseUpdate } = phoneCaseUpdateSlice.actions;
export const { reset: resetPhoneCaseDelete } = phoneCaseDeleteSlice.actions;
export const { reset: resetPhoneCaseToggleActive } =
  phoneCaseToggleActiveSlice.actions;

// ---------- COMBINED REDUCER ----------
export const phoneCasesReducer = combineReducers({
  phoneCasesList: phoneCasesListSlice.reducer,
  phoneCaseById: phoneCaseByIdSlice.reducer,
  createPhoneCase: phoneCaseCreateSlice.reducer,
  updatePhoneCase: phoneCaseUpdateSlice.reducer,
  deletePhoneCase: phoneCaseDeleteSlice.reducer,
  togglePhoneCaseActive: phoneCaseToggleActiveSlice.reducer,
});
